export default [
	{
		name: 'Survey',
		field: 'title',
		width: 'large'
	},
	{
		name: 'Description',
		field: 'text_for_text',
		width: 'large'
	},
	{
		name: 'Coins or Offer',
		field: 'points',
		width: 'medium',
		needsAll: true,
		prepData: (data) => {
			if (data.promotion_apikey !== '') return 'Offer';
			else if (data.points === 0) return 'None';
			else return data.points;
		}
	},
	{
		name: 'Question Count',
		width: 'medium',
		field: 'question_list',
		prepData: (data) => {
			return data.question_list.length
		}
	}
]



/** WEBPACK FOOTER **
 ** ./src/tables/surveys.js
 **/